import { storage } from '../../../vendors/firebase/firebase';

export default {
  async fetchUrl(imgPath) {
    storage.ref(imgPath)
      .getDownloadURL()
      .then((url) => console.log(url));
  },
};
